import { render, staticRenderFns } from "./TaskImage.vue?vue&type=template&id=d218894a&scoped=true&lang=pug"
import script from "./TaskImage.vue?vue&type=script&lang=js"
export * from "./TaskImage.vue?vue&type=script&lang=js"
import style0 from "./TaskImage.vue?vue&type=style&index=0&id=d218894a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d218894a",
  null
  
)

export default component.exports